import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { get as getCookie } from 'es-cookie';
import { injectable } from 'inversify';
import { Proto } from '../types/Proto';

/**
 * A basic dashboard axios client.
 */
@injectable()
abstract class DashboardAxiosApi {
  public constructor(protected prefix: string = '') {}

  /**
   * Makes a GET request.
   */
  protected async doGet<T = object>(url: string, params?: { [key: string]: Object }): Promise<AxiosResponse<T>> {
    const requestConfig: AxiosRequestConfig = { ...(await this.getDefaultRequestConfig()), params };

    return Axios.get<T>(`${this.prefix}${url}`, requestConfig);
  }

  /**
   * Makes a POST request.
   */
  protected async doPost<T = object>(
    url: string,
    data: Proto,
    extraHeaders?: { [k: string]: string }
  ): Promise<AxiosResponse<T>> {
    const requestConfig: AxiosRequestConfig = { ...(await this.getDefaultRequestConfig()) };
    if (extraHeaders) {
      requestConfig.headers = { ...requestConfig.headers, ...extraHeaders };
    }

    return Axios.post(`${this.prefix}${url}`, data.toJSON(), requestConfig);
  }

  protected async getDefaultRequestConfig(): Promise<AxiosRequestConfig> {
    return {
      headers: {
        _c: getCookie('c'), // csrf token
        'X-Use-Camel-Case-Proto-Models': 'true' // Require camel case in proto models.
      }
    };
  }
}

export { DashboardAxiosApi };
